/**
 * Signal posé juste après un login réussi : pas de données utiles, juste sa présence.
 * Déclencheur one-shot pour la modale des nouveautés, indépendant de la navigation ou
 * d'un rechargement — simple variable en mémoire, pas de cache/GC à gérer.
 */
let pending = false;

export function emitLoginSuccess() {
  pending = true;
}

/** Lit et remet à zéro le signal : renvoie `true` une seule fois par login. */
export function consumeLoginSuccess(): boolean {
  if (!pending) return false;
  pending = false;
  return true;
}
